/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M17 8V13.5C17 15.9853 14.9853 18 12.5 18V18C10.0147 18 8 15.9853 8 13.5V9C8 7.34315 9.34315 6 11 6V6C12.6569 6 14 7.34315 14 9V13.5C14 14.3284 13.3284 15 12.5 15V15C11.6716 15 11 14.3284 11 13.5V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M17 8V13.5C17 15.9853 14.9853 18 12.5 18V18C10.0147 18 8 15.9853 8 13.5V9C8 7.34315 9.34315 6 11 6V6C12.6569 6 14 7.34315 14 9V13.5C14 14.3284 13.3284 15 12.5 15V15C11.6716 15 11 14.3284 11 13.5V9M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.75 9C8.75 7.75736 9.75736 6.75 11 6.75C12.2426 6.75 13.25 7.75736 13.25 9V13.5C13.25 13.9142 12.9142 14.25 12.5 14.25C12.0858 14.25 11.75 13.9142 11.75 13.5V9C11.75 8.58579 11.4142 8.25 11 8.25C10.5858 8.25 10.25 8.58579 10.25 9V13.5C10.25 14.7426 11.2574 15.75 12.5 15.75C13.7426 15.75 14.75 14.7426 14.75 13.5V9C14.75 6.92893 13.0711 5.25 11 5.25C8.92893 5.25 7.25 6.92893 7.25 9V13.5C7.25 16.3995 9.6005 18.75 12.5 18.75C15.3995 18.75 17.75 16.3995 17.75 13.5V8C17.75 7.58579 17.4142 7.25 17 7.25C16.5858 7.25 16.25 7.58579 16.25 8V13.5C16.25 15.5711 14.5711 17.25 12.5 17.25C10.4289 17.25 8.75 15.5711 8.75 13.5V9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M17 8V13.5C17 15.9853 14.9853 18 12.5 18V18C10.0147 18 8 15.9853 8 13.5V9C8 7.34315 9.34315 6 11 6V6C12.6569 6 14 7.34315 14 9V13.5C14 14.3284 13.3284 15 12.5 15V15C11.6716 15 11 14.3284 11 13.5V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M17 8V13.5C17 15.9853 14.9853 18 12.5 18V18C10.0147 18 8 15.9853 8 13.5V9C8 7.34315 9.34315 6 11 6V6C12.6569 6 14 7.34315 14 9V13.5C14 14.3284 13.3284 15 12.5 15V15C11.6716 15 11 14.3284 11 13.5V9M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11 6.75C9.75736 6.75 8.75 7.75736 8.75 9V13.5C8.75 15.5711 10.4289 17.25 12.5 17.25C14.5711 17.25 16.25 15.5711 16.25 13.5V8C16.25 7.58579 16.5858 7.25 17 7.25C17.4142 7.25 17.75 7.58579 17.75 8V13.5C17.75 16.3995 15.3995 18.75 12.5 18.75C9.60051 18.75 7.25 16.3995 7.25 13.5V9C7.25 6.92893 8.92893 5.25 11 5.25C13.0711 5.25 14.75 6.92893 14.75 9V13.5C14.75 14.7426 13.7426 15.75 12.5 15.75C11.2574 15.75 10.25 14.7426 10.25 13.5V9C10.25 8.58579 10.5858 8.25 11 8.25C11.4142 8.25 11.75 8.58579 11.75 9V13.5C11.75 13.9142 12.0858 14.25 12.5 14.25C12.9142 14.25 13.25 13.9142 13.25 13.5V9C13.25 7.75736 12.2426 6.75 11 6.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
